import SwitchResponseData from '../interfaces/response/SwitchResponseData';
import {VlanLegendData} from '../interfaces/SwitchConnectivityState';
import distributionCenterLegendColors from '../VLANLegend/DCLegendColors';
interface FormatLegendDataProps {
  legendColorsInUse: Record<string, string>;
  legendData: VlanLegendData[];
}

function formatLegendData(apiData: SwitchResponseData): FormatLegendDataProps {
  let legendColorsInUse: Record<string, string> = {};
  let colorList: string[] = [...distributionCenterLegendColors];

  const legendData: VlanLegendData[] = apiData.vlanLegendItems.map(legendItem => {
    if (legendColorsInUse[legendItem.vlanNumber] === undefined) {
      if (legendItem.color?.length > 0) {
        legendColorsInUse[legendItem.vlanNumber] = legendItem.color;
      } else {
        // pick colors in reverse order due to the endpoint using the first colors in the distributionCenterLegendColors list
        if (colorList.length > 0) {
          const colorFromList = colorList.pop() as string;
          legendColorsInUse[legendItem.vlanNumber] = colorFromList;
        } else {
          // if a site needs more colors than the one provided in the distributionCenterLegendColors list
          // generate random colors
          const genRanHex = [...Array(6)]
            .map(() => Math.floor(Math.random() * 16).toString(16))
            .join('');
          legendColorsInUse[legendItem.vlanNumber] = `#${genRanHex}`;
        }
      }
    }

    if (legendItem.color?.length > 0) return {...legendItem, isSelected: false};

    return {
      ...legendItem,
      color: legendColorsInUse[legendItem.vlanNumber],
      isSelected: false,
    };
  });

  let defaultLegendPorts: VlanLegendData[] = [
    {
      vlanNumber: 'unknown',
      shortDescription: 'Unknown, not in DB',
      switchDeviceName: 'all',
      color: 'outline',
      isSelected: false,
    },
    {
      vlanNumber: 'Plug Icon',
      shortDescription: 'Device connected to port',
      switchDeviceName: 'all',
      color: '#ffffff',
      isSelected: false,
    },
  ];

  return {
    legendColorsInUse,
    legendData: [...legendData, ...defaultLegendPorts],
  };
}

export default formatLegendData;
